import React, { useEffect } from 'react';
import officer from '../assets/public_officerDostainDashti.jpg';
import AOS from 'aos';
import 'aos/dist/aos.css';
import rect from '../assets/animat/rect.png'
import coma from '../assets/animat/Group 396.png'
import recttop from '../assets/animat/react-top.png'
import round from '../assets/animat/side-round.png'
import { useTypewriter } from 'react-simple-typewriter'



function PublicMsg() {
  const [text] = useTypewriter({
    words: ['Dostain Dashti'],
    loop: 0
  })
  useEffect(() => {
    AOS.init({ duration: '1500', delay: '200' });
  }, []);

  return (
    <>

      <div className="container ">
        <div className="rectTop">
          <img src={recttop} alt="" />
          <img src={round} alt="" />

        </div>
        <div className="rect-box">
          <img src={rect} alt="" />
        </div>



        <div className="publicMsg">


          <div className="row flex-con">

            <div className="col-lg-4">
              <div className="officer-img">
                <img src={officer} alt="" />
              </div>
            </div>

            <div className="col-lg-8 para-section">
              <div className="para pub-para pub-heading  head-befor" data-aos="zoom-in">

                <div className="coma-box">
                  <h1>Public Message</h1>
                  <img src={coma} alt="" />
                </div>
                <div className='officer_name' >

                  <h2><span>{text}</span></h2>
                </div>
                <div className="par">

                  <h5>(SSP Traffic)</h5>
                  <p data-aos="zoom-in">
                    Quetta is not just a city of roads and signals; it is our shared home. Every day, thousands of fathers, mothers, children, students, and workers step onto these roads with one simple hope: to reach their destination safely. Traffic discipline is not a matter of fines or enforcement alone—it is a matter of life, respect, and care for one another.
                    I request you, from the heart, to follow traffic rules, wear helmets and seatbelts, respect pedestrian crossings, and show patience on the road. A few extra seconds of waiting can save a lifetime of regret. Reckless driving, wrong parking, and ignoring signals do not just endanger you—they put innocent lives at risk.
                    The Traffic Police of Quetta stands beside you, not against you. Our duty is to guide, protect, and serve, but real change can only come when citizens and police walk together with mutual trust and responsibility. Let us teach our children by example and make our roads safer for the elderly, the young, and the vulnerable.
                    For the sake of your family, your city, and your own life—drive with care, follow the law, and respect the road. Together, we can make Quetta a safer, more disciplined, and more humane city.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default PublicMsg;
